<script>
export default {
  props: {
    pointers: Array,
  },
  computed: {
    subdomain() {
      return this.cname.value.split('.').slice(0, -2).join('.')
    },
    domain() {
      return this.cname.value.split('.').slice(-2).join('.')
    },
    cname() {
      return this.pointers.find(({ type }) => type === 'CNAME')
    },
    a() {
      return this.pointers.find(({ type }) => type === 'A')
    },
  },
}
</script>

<template>
  <ol>
    <li>
      Gå til <a href="https://www.webhuset.no/logg-inn/kundesenter">Webhuset</a> sitt nettsted og logg inn med
      brukernavn og passord.
    </li>
    <li>
      Naviger til "Domene" og trykk på <b>{{ domain }}</b>
    </li>
    <li>Gå til "DNS > DNS-oppføringer"</li>
    <li>Trykk på "Ny oppføring" og "CNAME-oppføring"</li>
    <ul>
      <li>
        I feltet for "Oppføring", skriv inn <b>{{ subdomain }}</b>
      </li>
      <li>
        I feltet for "Alias av", skriv inn <b>{{ cname.target }}</b>
      </li>
      <li>Lagre endringene ved å trykke på "Opprett"</li>
    </ul>
    <template v-if="a">
      <li>Trykk på "Ny oppføring" og "A-oppføring"</li>
      <ul>
        <li>I feltet for "Oppføring", la det stå tomt</li>
        <li>
          I feltet for "Mål", skriv inn <b>{{ a.target }}</b>
        </li>
        <li>Lagre endringene ved å trykke på "Opprett"</li>
      </ul>
    </template>
    <li>Dersom du har en annen CNAME peker som benytter "Oppføring" <b>{{ subdomain }}</b> (se pkt. 4), må denne slettes slik at domenet fungerer riktig</li>
    <template v-if="a">
      <li>Dersom du har en annen A peker med "Oppføring" som er tom (se pkt. 5), må denne slettes slik at domenet fungerer riktig</li>
    </template>
  </ol>
</template>
